/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1EarnedReward
 */
export interface V1EarnedReward {
    /**
     *
     */
    id: string
    /**
     *
     */
    status: V1EarnedRewardStatusEnum
    /**
     *
     */
    durationDays: number
    /**
     *
     */
    createdAt?: number
    /**
     *
     */
    grantedAt?: number
    /**
     *
     */
    deadline?: number
}

/**
 * @export
 */
export const V1EarnedRewardStatusEnum = {
    Pending: 'pending',
    Held: 'held',
    Granting: 'granting',
    Granted: 'granted',
    Rejected: 'rejected',
    Failed: 'failed'
} as const
export type V1EarnedRewardStatusEnum =
    (typeof V1EarnedRewardStatusEnum)[keyof typeof V1EarnedRewardStatusEnum]

/**
 * Check if a given object implements the V1EarnedReward interface.
 */
export function instanceOfV1EarnedReward(
    value: object
): value is V1EarnedReward {
    if (!('id' in value) || value['id'] === undefined) return false
    if (!('status' in value) || value['status'] === undefined) return false
    if (!('durationDays' in value) || value['durationDays'] === undefined)
        return false
    return true
}

export function V1EarnedRewardFromJSON(json: any): V1EarnedReward {
    return V1EarnedRewardFromJSONTyped(json, false)
}

export function V1EarnedRewardFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1EarnedReward {
    if (json == null) {
        return json
    }
    return {
        id: json['id'],
        status: json['status'],
        durationDays: json['durationDays'],
        createdAt: json['createdAt'] == null ? undefined : json['createdAt'],
        grantedAt: json['grantedAt'] == null ? undefined : json['grantedAt'],
        deadline: json['deadline'] == null ? undefined : json['deadline']
    }
}

export function V1EarnedRewardToJSON(json: any): V1EarnedReward {
    return V1EarnedRewardToJSONTyped(json, false)
}

export function V1EarnedRewardToJSONTyped(
    value?: V1EarnedReward | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        id: value['id'],
        status: value['status'],
        durationDays: value['durationDays'],
        createdAt: value['createdAt'],
        grantedAt: value['grantedAt'],
        deadline: value['deadline']
    }
}
